import { CampaignType } from '@modules/campaigns/models/campaign.model';
import { CustomerCaseListWorkflowOperationFilter } from '@modules/customer-case-campaings-instances/Model/workflow-insitance.model';

export enum CAMPAIGN_TYPE {
  DRIP = 'drip',
  PILL = 'pill',
}

export interface CampaignNewModel {
  id: string;
  type?: CampaignType;
  name: string;
  purpose: string;
  status: string;
  silenced: boolean;
  collectors?: any;
  collectorIds?: string[];
  includedSegmentIds: string[];
  triggers: string[];
  collectorCount?: string;
  dataPills?: CampaignPill[];
  bucket?: {
    finish: number;
    start: number;
  };
  nodes?: {
    nodeId: string;
    type: string;
    position: number;
    parameters: Record<string, any>;
  }[];
}

export enum CollectorStatus {
  Running = 'running',
  Paused = 'paused',
  Stopped = 'stopped',
}

export interface CampaignCollectorBase {
  id: string;
  campaignId: string;
  collectorId: string;
  status: CollectorStatus | string;
  customerCaseCount: number;
}

export interface CampaignCollector extends CampaignCollectorBase {}

export interface CampaignCollectorWithDetail extends CampaignCollectorBase {
  detail: CollectorDetail;
}

export interface CollectorDetail {
  id: string;
  name: string;
  alias: string;
  brandId: string;
  tenantId: string;
  taxEntityId: string;
  regionalConfigId: string;
  managementFeeConfig: string;
  currency: string;
  channelConfigIds: string[];
  eventHookConfigIds: string[];
  feedbackOptionIds: string[];
  paymentGatewayIds: string[];
  serviceIds: string[];
}

export enum CampaignActionEnum {
  Published = 'published',
  Paused = 'paused',
  Unpublished = 'unpublished',
  Draft = 'draft',
}

export type status = {
  label: string;
  value: 'published' | 'unpublished' | 'draft';
  count?: number;
  icon: string;
};

export const tabStatusNew: status[] = [
  {
    label: 'DATA.MODULES.CAMPAINGS.LIST.TABLE.TYPES.ACTIVE',
    value: 'published',
    icon: 'pi pi-play',
  },
  {
    label: 'DATA.MODULES.CAMPAINGS.LIST.TABLE.TYPES.UNPUBLISHED',
    value: 'unpublished',
    icon: 'pi pi-bookmark',
  },
  {
    label: 'DATA.MODULES.CAMPAINGS.LIST.TABLE.TYPES.DRAFT',
    value: 'draft',
    icon: 'pi pi-inbox',
  },
];

export interface CampaignPill {
  id: string;
  workflowId: string;
  createdAt: string;
  status: CampaignPillActionEnum | string;
  customerCaseCount: number;
  customerCaseIds: string[];
  filters?: PillAppliedFilters | null;
}

export interface PillAppliedFilters {
  tenantId?: string;
  collectorIds?: string[];
  workflowIds?: WorkflowFilter | null;
  workflows?: WorkflowFilter | null;
  nodeId?: string | null;
  segmentIds?: string | null;
  statuses?: string[];
  minPendingAmount?: number | null;
  maxPendingAmount?: number | null;
  customerExternalIds?: string[];
  operationExternalIds?: string[];
  __typename?: string;
}

export interface WorkflowFilter {
  ids: string[];
  operation: CustomerCaseListWorkflowOperationFilter;
}

export enum CampaignPillActionEnum {
  Draft = 'draft',
  Published = 'published',
  Unpublished = 'unpublished',
}

export enum CampaignCollectorActionEnum {
  Pause = 'paused',
  Running = 'running',
}

export class CampaignUIModel implements CampaignNewModel {
  id!: string;
  type?: CampaignType;
  name!: string;
  purpose!: string;
  status!: string;
  silenced!: boolean;
  collectors?: any[];
  includedSegmentIds!: string[];
  triggers!: string[];
  customerCaseCount?: number;
  collectorCount?: string;
  dataPills?: CampaignPill[];
  bucket?: { finish: number; start: number };
  nodes?: { nodeId: string; type: string; position: number; parameters: Record<string, any> }[];

  collectorIds?: string[];
  collectorsEnabled?: CampaignCollectorWithDetail[];
  collectorsDisabled?: CampaignCollectorWithDetail[];

  collectorsLoaded = false;
  loadingCollectors = false;

  constructor(public base: CampaignNewModel) {
    Object.assign(this, base);
  }
}
